<template>
  <div>
    <h4>Dashboard</h4>
  </div>
</template>

<script>
  export default {

  }
</script>
